import schoolManager from './admin/schoolManagement.js'
import homePageShow from './admin/homePageShow'
import major from './admin/majorManager.js'
import majorCourse from './admin/majorCourse.js'
import certificates from './admin/Certificates.js'
import subjects from './admin/Subject.js'
import textbooks from './admin/TxtBook.js'
import txtBookChapter from './admin/txtBookChapter.js'
import CourseCriteriaTree from './admin/CourseCriteriaTree.js'
import ResourceOpenSchool from './admin/ResourceOpenSchool.js'
import CertificatesManage from './admin/CertificatesManage.js'
import BaseCourseManage from './admin/BaseCourseManage.js'
import MajorCourseManage from './admin/MajorCourseManage.js'
import resource from './admin/resource.js'
import paperType from './admin/paperType.js'
import banner from './admin/banner.js'
import statisticalAnalysis from './admin/StatisticalAnalysis.js'
import useAnalysis from './admin/UseAnalysis.js'
import examBanner from './admin/examBanner.js'
import personalManager from './admin/personalManagement.js'
import basicCourse from './admin/basicCourse.js'
import scoreManagement from './admin/scoreManagement.js'
import allSchoolExam from './admin/allSchoolExam.js'
import scoreSchoolManagement from './admin/scoreSchoolManagement.js'
import scoreDeanManagement from './admin/scoreDeanManagement.js'
import examinationDetails from './admin/examinationDetails.js'
import teachingMaterialExr from './admin/teachingMaterialExr.js'
import School from './admin/school.js'
import Students from './admin/student.js'
import cutScreenClass from './admin/cutScreenClass.js'
import cutScreenClassUser from './admin/cutScreenClassUser.js'
import cutScreenUser from './admin/cutScreenUser.js'
// 大连学业水平质量抽测填报
import FillManagement from "./fillManagement/fillManagement";
import FillDetails from "./fillManagement/fillDetails";
import AttachmentList from "./fillManagement/attachmentList";
import FillList from "./fillManagement/fillList";
import {uploadFile} from "../fetch/http";
import UploadFile from "./fillManagement/uploadFile";
import EvaluationDetails from "./fillManagement/evaluationDetails";
import ReportDetails from "./admin/reportDetails";
import SchoolReportDetails from "./admin/schoolReportDetails";


const homePage = resolve => require(['@/components/admin/HomePage.vue'], resolve);

export default {
  path: '/homePage',
  component: homePage,
  meta: {
    title: '首页'
  },
  children: [
    schoolManager,
    homePageShow,
    basicCourse,
    major,
    majorCourse,
    certificates,
    subjects,
    textbooks,
    CertificatesManage,
    MajorCourseManage,
    txtBookChapter,
    ResourceOpenSchool,
    resource,
    paperType,
    banner,
    statisticalAnalysis,
    useAnalysis,
    scoreManagement,
    scoreSchoolManagement,
    teachingMaterialExr,
    scoreDeanManagement,
    allSchoolExam,
    examinationDetails,
    ReportDetails,
    examBanner,
    School,
    personalManager,
    BaseCourseManage,
    CourseCriteriaTree,
    Students,
    cutScreenClass,
    cutScreenClassUser,
    cutScreenUser,
    FillManagement,
    FillDetails,
    AttachmentList,
    FillList,
    UploadFile,
    EvaluationDetails,
    SchoolReportDetails
  ]
}



// WEBPACK FOOTER //
// ./src/router/homePage.js